var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"color":"warning","small":_vm.small}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v(" "+_vm._s(_vm.mdiCalendarClock())+" ")]),(!_vm.small)?[_vm._v(" Заполнить до:   ")]:_vm._e(),_c('strong',[_vm._v(_vm._s(_vm.getDeadline))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }